import { Dispatch } from "redux";
import { AgeRatingList } from "../../models/AgeRatingModel";
import { getAll } from "../../services/age_rating";
import { UPDATE_API_FETCHING } from "../api_details/types";
import { FETCH_AGE_RATINGS } from "./types";

export const fetchAgeRatings =
    () =>
    async (dispatch: Dispatch): Promise<AgeRatingList> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await getAll();

            dispatch({
                type: FETCH_AGE_RATINGS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };
